// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wSjD","rootNoMargin":"styles_rootNoMargin__3bUQ4"};